<template>
    <div class="gather">
        <div class="container">
            <breadcrumbs :dom="crumbsItem" />
            <div class="gether_item" v-for="(collection, index) in collectionList" :key="index">
                <div class="products collection">
                    <ProductItemBox :products="collection.ClassGroup" :products_title="collection.TypeName" />
                </div>
                <loadmore v-if="!collection.lastPage" @loadMore="getQueryCollectionList(collection.TypeID, collection.CurrentPage)" :trigger-on-scroll="false" />
            </div>
        </div>
    </div>
</template>

<script>
    import Breadcrumbs from '@/components/partial/Breadcrumbs'
    import ProductItemBox from '@/components/products/items/ItemBox'
    import Loadmore from '@/components/partial/Loadmore'
    import classApi from '@/api/class'
    import userMixin from '@/mixins/user'

    export default {
        mixins: [userMixin],
        data() {
            return {
                crumbsItem: [{
                        text: '首頁',
                        to: {
                            name: 'home'
                        },
                    },
                    {
                        text: '我的收藏',
                        active: true
                    }
                ],
                perPage: 4,
                collectionList: [],
            }
        },
        components: {
            Breadcrumbs,
            ProductItemBox,
            Loadmore,
        },
        created() {
            this.getQueryCollectionList()
        },
        methods: {
            initUser() {
                this.$router.push({
                    name: 'home'
                });
            },
            getQueryCollectionList(TypeID, CurrentPage = 1) {
                let callback = this.resetCollectionList;

                if (!TypeID && CurrentPage == 1) {
                    this.collectionList = [];
                } else {
                    callback = this.pushCollectionList;
                }

                classApi.queryCollectionList({
                    PerPage: this.perPage,
                    TypeID,
                    CurrentPage,
                }, callback);
            },
            resetCollectionList(data) {
                this.collectionList = data ? data : [];
                for (let collection of this.collectionList) {
                    let lastPage = false;

                    if (collection.ClassGroup.length < this.perPage) {
                        lastPage = true;
                    }
                    
                    this.$set(collection, 'lastPage', lastPage);
                    this.$set(collection, 'CurrentPage', 2);
                }
            },
            pushCollectionList(data) {
                data = data ? data : [];
                for (let collection of data) {
                    let originCollection = this.collectionList.find(ele => ele.TypeID == collection.TypeID);

                    if (originCollection) {
                        let lastPage = false;

                        if (collection.ClassGroup.length < this.perPage) {
                            lastPage = true;
                        }

                        originCollection.ClassGroup = originCollection.ClassGroup.concat(collection.ClassGroup);

                        this.$set(originCollection, 'lastPage', lastPage);
                        this.$set(originCollection, 'CurrentPage', originCollection.CurrentPage + 1);
                    }
                }
            },
        },
    }
</script>